import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Colors, TouchIcon } from '@notino/react-styleguide';

import messages from '../../../messages';

import { ModiFaceWrapper, TextWrapper } from './styled';

interface IModiFaceOverlayProps {
  onClick: (e: React.MouseEvent) => void;
}

export const ModiFaceOverlay: React.FC<IModiFaceOverlayProps> = React.memo(
  ({ onClick }) => (
    <ModiFaceWrapper onClick={onClick}>
      <TouchIcon color={Colors.basicInverse} width="32px" height="37px" />
      <TextWrapper>
        <FormattedMessage {...messages.tryItOnYourself} />
      </TextWrapper>
    </ModiFaceWrapper>
  )
);
